module.exports = require('buffer')



//////////////////
// WEBPACK FOOTER
// ./~/safe-buffer/browser.js
// module id = 56
// module chunks = 0